/* Maison Daryah – gift box pickers (fabric, scent, charm).
   Each [data-md-fabric-picker] asks for data-max choices (default 2). Bridal Box: 2 fabrics + a scent;
   Mommy & Me: 1 fabric; Birthday Box: 1 fabric + a scent + a charm.
   The box cannot be added to the cart until every picker on the page is complete.
   Each picker writes its choices to its own visible line item properties (its [data-md-fabric-input]s);
   the variant IDs of everything chosen on the page go to the hidden _fabric_variant_ids property,
   which the Shopify Flow workflow uses to subtract the chosen fabric, perfume and charm from stock. */
(() => {
  if (window.__mdPickers) {
    window.__mdPickers.scan();
    return;
  }

  const MSGS = {
    1: { need: 'Please choose a fabric first · الرجاء اختيار القماش أولاً', full: '' },
    2: {
      need: 'Please choose 2 fabrics first · الرجاء اختيار قطعتين من القماش أولاً',
      full: "You've chosen 2. Tap one to change it · تم اختيار قطعتين، اضغط على إحداها لتغييرها",
    },
  };

  const css = `
  .md-fp{display:block;width:100%}
  .md-fp__heading{margin:0 0 4px;font-weight:500}
  .md-fp__desc{margin:0 0 12px;font-size:.85em;opacity:.7}
  .md-fp__chips{display:flex;flex-wrap:wrap;gap:6px;margin:0 0 12px}
  .md-fp__chip{font:inherit;font-size:.78em;letter-spacing:.04em;padding:6px 12px;border:1px solid rgba(43,33,28,.25);border-radius:999px;background:transparent;color:inherit;cursor:pointer}
  .md-fp__chip.is-active{background:#2b211c;border-color:#2b211c;color:#f6f1ea}
  .md-fp__grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(92px,1fr));gap:10px;max-height:400px;overflow-y:auto;padding:2px 4px 2px 2px;overscroll-behavior:contain}
  .md-fp__tile{font:inherit;display:flex;flex-direction:column;gap:5px;padding:0;border:0;background:none;color:inherit;text-align:left;cursor:pointer}
  .md-fp__tile[hidden]{display:none}
  .md-fp__img{position:relative;display:block;aspect-ratio:1/1;overflow:hidden;outline:1px solid rgba(43,33,28,.12);outline-offset:0;transition:outline-color .15s}
  .md-fp__img img{width:100%;height:100%;object-fit:cover;display:block}
  .md-fp__tile:hover .md-fp__img{outline-color:rgba(43,33,28,.45)}
  .md-fp__tile.is-picked .md-fp__img{outline:2px solid #2b211c;outline-offset:-2px}
  .md-fp__badge{position:absolute;top:6px;right:6px;width:22px;height:22px;border-radius:50%;background:#2b211c;color:#f6f1ea;font-size:12px;line-height:22px;text-align:center;display:none}
  .md-fp__tile.is-picked .md-fp__badge{display:block}
  .md-fp__name{font-size:.74em;line-height:1.25}
  .md-fp__status{margin:12px 0 0;font-size:.85em}
  .md-fp__hint{margin:6px 0 0;font-size:.85em;color:#8b3a2b}
  .md-fp__tile[disabled]{cursor:not-allowed}
  .md-fp__so{font-size:.68em;letter-spacing:.04em;opacity:.8}
  /* scent picker: names only */
  .md-fp--names .md-fp__grid{display:flex;flex-wrap:wrap;gap:8px;max-height:none;overflow:visible;padding:0}
  .md-fp--names .md-fp__tile{flex-direction:row;align-items:baseline;gap:6px;padding:9px 14px;border:1px solid rgba(43,33,28,.25);background:transparent;transition:border-color .15s,background .15s}
  .md-fp--names .md-fp__tile:hover{border-color:rgba(43,33,28,.6)}
  .md-fp--names .md-fp__name{font-size:.82em;letter-spacing:.02em}
  .md-fp--names .md-fp__tile.is-picked{background:#2b211c;border-color:#2b211c;color:#f6f1ea}
  .md-fp--names .md-fp__tile[disabled]{opacity:.45}
  .md-fp--names .md-fp__tile[disabled] .md-fp__name{text-decoration:line-through}
  /* charm picker: three photo tiles */
  .md-fp--charms .md-fp__grid{grid-template-columns:repeat(3,minmax(0,1fr));max-height:none;overflow:visible;gap:12px 10px}
  .md-fp--charms .md-fp__img{background:#fff}
  .md-fp--charms .md-fp__img img{object-fit:contain}
  .md-fp--charms .md-fp__tile[disabled] img{opacity:.4;filter:grayscale(.5)}
  .md-fp--charms .md-fp__so{position:absolute;left:6px;bottom:6px;background:#f6f1ea;color:#2b211c;padding:3px 6px}
  .md-fp__soldout{margin:12px 0 0;padding:.8rem .9rem;border:1px solid #c9a99a;background:#fbf3ef;color:#7a3626;font-size:.85rem}
  .accelerated-checkout-block{display:none !important}
  html:not(.md-fabrics-ready) .add-to-cart-button{opacity:.45;cursor:not-allowed}
  `;

  const pickers = [];
  const allReady = () => pickers.every((p) => p.ready());

  // Every chosen variant on the page (fabrics, scent, charm) goes to the hidden _fabric_variant_ids input(s).
  function syncShared() {
    const ids = pickers.flatMap((p) => p.vids());
    document.querySelectorAll('[data-md-fabric-ids]').forEach((i) => { i.value = ids.join(','); });
    document.documentElement.classList.toggle('md-fabrics-ready', allReady());
  }

  function init(root) {
    if (!root || root.dataset.mdInit) return;
    root.dataset.mdInit = '1';

    if (!document.getElementById('md-fp-style')) {
      const style = document.createElement('style');
      style.id = 'md-fp-style';
      style.textContent = css;
      document.head.appendChild(style);
    }

    const MAX = Math.max(1, parseInt(root.dataset.max, 10) || 2);
    const MSG_NEED = root.dataset.need || (MSGS[MAX] || MSGS[2]).need;
    const MSG_FULL = root.dataset.full || (MSGS[MAX] || MSGS[2]).full;
    const tiles = [...root.querySelectorAll('[data-md-fabric]')];
    const inputs = [...root.querySelectorAll('[data-md-fabric-input]')];
    const countEl = root.querySelector('[data-md-count]');
    const summaryEl = root.querySelector('[data-md-summary]');
    const hintEl = root.querySelector('[data-md-hint]');
    const picked = [];

    const label = (t) => (t.dataset.type ? `${t.dataset.title} (${t.dataset.type})` : t.dataset.title);

    function hint(msg) {
      if (!hintEl) return;
      hintEl.textContent = msg || '';
      hintEl.hidden = !msg;
    }

    function update() {
      tiles.forEach((t) => {
        const i = picked.indexOf(t);
        t.classList.toggle('is-picked', i > -1);
        t.setAttribute('aria-pressed', i > -1 ? 'true' : 'false');
        const badge = t.querySelector('[data-md-badge]');
        if (badge) badge.textContent = i > -1 ? String(i + 1) : '';
      });
      inputs.forEach((input, i) => {
        input.value = picked[i] ? label(picked[i]) : '';
      });
      if (countEl) countEl.textContent = String(picked.length);
      if (summaryEl) summaryEl.textContent = picked.length ? '· ' + picked.map((t) => t.dataset.title).join(' + ') : '';
      syncShared();
    }

    root.addEventListener('click', (e) => {
      const chip = e.target.closest('[data-filter]');
      if (chip) {
        root.querySelectorAll('[data-filter]').forEach((c) => c.classList.toggle('is-active', c === chip));
        const f = chip.dataset.filter;
        tiles.forEach((t) => { t.hidden = !(f === 'all' || t.dataset.cat === f); });
        return;
      }
      const tile = e.target.closest('[data-md-fabric]');
      if (!tile || tile.disabled) return;
      const i = picked.indexOf(tile);
      if (i > -1) {
        picked.splice(i, 1);
      } else if (picked.length >= MAX && MAX === 1) {
        picked.splice(0, 1, tile); // single choice: tapping another one swaps it
      } else if (picked.length >= MAX) {
        hint(MSG_FULL);
        return;
      } else {
        picked.push(tile);
      }
      hint('');
      update();
    });

    pickers.push({
      root,
      formId: root.dataset.formId,
      ready: () => picked.length === MAX,
      vids: () => picked.map((t) => t.dataset.vid).filter(Boolean),
      needHint: () => hint(MSG_NEED),
    });
    update();
  }

  const isOurs = (el) => {
    const ids = new Set(pickers.map((p) => p.formId));
    const form = el.closest('form');
    if (form && ids.has(form.getAttribute('id'))) return true;
    if (ids.has(el.getAttribute('form'))) return true;
    return !!el.closest('sticky-add-to-cart');
  };

  function stop(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    const missing = pickers.filter((p) => !p.ready());
    missing.forEach((p) => p.needHint());
    if (missing[0]) missing[0].root.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  // Block Add to cart (main button and sticky bar) until every picker is complete.
  // Capture phase on window, so this runs before the theme's own handlers (add-to-cart animation).
  window.addEventListener('click', (e) => {
    if (!pickers.length || allReady()) return;
    const btn = e.target.closest && e.target.closest('.add-to-cart-button, button[name="add"]');
    if (btn && isOurs(btn)) stop(e);
  }, true);

  window.addEventListener('submit', (e) => {
    if (!pickers.length || allReady()) return;
    const id = e.target.getAttribute && e.target.getAttribute('id');
    if (pickers.some((p) => p.formId === id)) stop(e);
  }, true);

  const scan = () => document.querySelectorAll('[data-md-fabric-picker]').forEach(init);
  window.__mdPickers = { scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
})();
